<ng-container *transloco="let t">
  <ng-template #headerTpl>
    <div class="flex items-center gap-3">
      <div class="p-2 rounded-lg bg-primary-soft">
        <div class="flex items-center justify-center size-6 rounded-full shrink-0 text-primary">
          <mat-icon svgIcon="buildings-outline" />
        </div>
      </div>
      <div class="flex flex-col">
        <h2 class="font-semibold text-ink-heading">{{ t('ORGANIZATIONS.SWITCH_ORGANIZATION') }}</h2>
        <p class="text-xs text-ink-tertiary">{{ t('ORGANIZATIONS.SELECT_WORKSPACE') }}</p>
      </div>
    </div>
  </ng-template>

  <dss-libs-ui-base-modal [header]="headerTpl" [showClose]="true" (closed)="closeModal()">
    <div class="px-6 pt-5 pb-4 flex flex-col gap-3 max-h-80 overflow-y-auto">
      @if (isLoading()) {
      <dss-libs-ui-modal-list-skeleton [rows]="4" />
      } @else { @if (currentClient(); as currentClient) {
      <div class="flex gap-3 items-center p-3 rounded-lg bg-primary-tint">
        <div class="size-9 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <span class="text-xs font-semibold text-white">{{ getInitials(currentClient.name) }}</span>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-0">
          <p class="text-sm font-semibold text-ink-heading truncate">{{ currentClient.name }}</p>
          <p class="text-xs text-ink-tertiary">
            {{ currentClient.membersCount | translocoDecimal }} {{ t('ORGANIZATIONS.MEMBERS') }}
          </p>
        </div>
        <span class="px-2.5 py-0.5 rounded-full bg-blue-faint text-xs font-semibold text-primary shrink-0">
          {{ t('ORGANIZATIONS.CURRENT') }}
        </span>
      </div>
      } @for (client of userClients(); track client.id) {
      <button
        class="flex gap-3 items-center p-3 rounded-lg w-full text-start hover:bg-primary-tint transition-colors cursor-pointer"
        (click)="changeClient(client.id!)"
      >
        <div class="size-9 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <span class="text-xs font-semibold text-white">{{ getInitials(client.name) }}</span>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-0">
          <p class="text-sm font-semibold text-ink-heading truncate">{{ client.name }}</p>
          <p class="text-xs text-ink-tertiary">
            {{ client.membersCount | translocoDecimal }} {{ t('ORGANIZATIONS.MEMBERS') }}
          </p>
        </div>
      </button>
      } }
    </div>
    <div class="w-full px-6 pb-5">
      <dss-libs-ui-button
        class="w-full"
        variant="outline"
        [iconMetaData]="{
          icon: 'arrow-right',
          isSvg: true,
          afterContent: true,
          appliedClasses: 'size-4! text-primary'
        }"
        label="CREATE_ORGANIZATION.SUBMIT_BUTTON"
        (click)="navigateToCreateOrganization()"
        appliedClasses="w-full"
      />
    </div>
  </dss-libs-ui-base-modal>
</ng-container>
